<template>
	<div
		class="job-card-selection relative tw-p-2 tw-flex tw-gap-1 tw-justify-center tw-items-center cursor-pointer"
		:class="{
			'job-card-selection-focused': focused,
			'job-card-selection-checked': checked,
		}"
		@click="$emit('click')"
	>
		<div v-if="focused" class="job-card-selection-focused-cover tw-items-center tw-justify-center">
			<span class="tw-text-center tw-flex tw-items-center tw-gap-2">
				<check-icon v-if="checked" :color="checked ? 'primary' : ''"></check-icon>
				<b>{{ text }}</b>
			</span>
		</div>
		<div class="tw-flex tw-gap-2 tw-items-center tw-justify-center">
			<check-icon :color="checked ? 'primary' : ''"></check-icon>
			<span class="tw-leading-text" :class="[checked ? 'tw-text-app-color-primary' : 'tw-text-app-color-secondary']">
				<b>{{ text }}</b>
			</span>
		</div>
	</div>
</template>

<script>
import CheckIcon from '../../../../shared/components/icons/check-icon';

export default {
	name: 'job-card-selection',
	components: { CheckIcon },
	props: ['text', 'focused', 'checked'],
};
</script>

<style scoped lang="scss">
.job-card-selection {
	border: 2px solid var(--app-color-secondary);
	border-radius: 5px;
	color: var(--app-color-secondary);

	.job-card-selection-focused-cover {
		display: none;
	}

	&.job-card-selection-focused {
		.job-card-selection-focused-cover {
			display: flex;
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			background-color: var(--app-color-secondary);
			span {
				color: white;
			}
		}
	}

	&.job-card-selection-checked {
		color: var(--app-color-primary);
	}

	svg {
		min-width: 20px;
		max-width: 20px;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/components/second-step/components/job-card-selection.vue